import "../../../../Assets/Styles/Dashboard/course_lesson.css";

const CourseLessonRight = ({ setVideo, items }) => {
  return (
    <div className="accordion">
      {items.map((item, index) => (
        <div key={index} className="accordion-item">
          <div
            onClick={() => setVideo(item?.videos)}
            className="accordion-title"
          >
            {item?.name}
            <i className="fa-solid fa-play text-base text-[#ffffff]"></i>
          </div>
        </div>
      ))}
    </div>
  );
};

export default CourseLessonRight;
